<template>
  <li class="hvr-icon-drop" v-if="mobile != 'yes'">
    <a>
      {{ getLang($i18n.locale) }}
      <span class="fa fa-sort-desc"></span>
    </a>
    <div class="sub-menu">
      <ul>
        <li v-for="(lang, i) in $i18n.availableLocales" :key="`Lang${i}`">
          <a
            v-if="lang != $i18n.locale"
            :value="lang"
            href="#"
            @click.prevent="setLocale(lang)"
            >{{ getLang(lang) }}</a
          >
        </li>
      </ul>
    </div>
  </li>
  <li v-else class="has-submenu garden-hv-child-color-primary">
    <a>{{ getLang($i18n.locale) }}</a>
    <ul class="submenu">
      <li
        v-for="(lang, i) in $i18n.availableLocales"
        :key="`Lang${i}`"
        class="garden-hv-child-color-primary"
      >
        <a
          v-if="lang != $i18n.locale"
          :value="lang"
          href="#"
          @click.prevent="setLocale(lang)"
          >{{ getLang(lang) }}</a
        >
      </li>
    </ul>
  </li>
</template>

<script>
import Axios from 'axios';
import APPURL from '../constant';
export default {
  name: 'locale-changer',
  props: {
    mobile: String
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      //var name = this.$route.name;
      var originalName = this.$route.name;
      var name = originalName.substring(0, originalName.length - 2);
      var lang = originalName.slice(-2);
      if (lang == 'En') {
        name += 'Fr';
      } else {
        name += 'En';
      }
      locale = this.$i18n.t(locale);
      //console.log(name);
      //console.log(this.$route.params);
      var request = '';
      var slug = `${this.$route.params.slug}`;
      if (this.$route.params.type) {
        if (this.$route.params.type == 'project') {
          request = APPURL.LINK + 'project-by-slug/' + slug;
          Axios.get(request).then(response => {
            this.post = response.data.data.results[0];
            //console.log(this.post.locale);
            var lang = '';
            if (this.post.locale == 'en') {
              lang = 'fr';
            } else {
              lang = 'en';
            }
            var project_id = this.post.project_id;
            var nextRequest =
              APPURL.LINK + 'project/' + lang + '/' + project_id;
            //console.log(this.post);
            //console.log(nextRequest);
            Axios.get(nextRequest).then(response => {
              this.$router.push({
                name: 'SinglePost',
                params: {
                  slug: response.data.data.results[0].slug,
                  lang: lang
                }
              });
              //console.log(response.data.data.results[0].slug);
            });
          });
          //console.log("we are in a project post");
        } else if (this.$route.params.type == 'covid') {
          request = APPURL.LINK + 'covid-by-slug/' + slug;
          Axios.get(request).then(response => {
            this.post = response.data.data.results[0];
            //console.log(this.post.locale);
            var lang = '';
            if (this.post.locale == 'en') {
              lang = 'fr';
            } else {
              lang = 'en';
            }
            var covid_id = this.post.covid_id;
            var nextRequest = APPURL.LINK + 'covid/' + lang + '/' + covid_id;
            //console.log(this.post);
            //console.log(nextRequest);
            Axios.get(nextRequest).then(response => {
              this.$router.push({
                name: 'SinglePost',
                params: {
                  slug: response.data.data.results[0].slug,
                  lang: lang
                }
              });
              //console.log(response.data.data.results[0].slug);
            });
          });
          //console.log("we are in a project post");
        } else if (
          this.$route.params.type == 'ghanaHub' ||
          this.$route.params.type == 'blogs' ||
          this.$route.params.type == 'news'
        ) {
          request = APPURL.LINK + 'post-by-slug/' + slug;
          //console.log("slug is " + slug);
          Axios.get(request).then(response => {
            this.post = response.data.data.results.post;
            var lang = '';
            if (this.post.locale == 'en') {
              lang = 'fr';
            } else {
              lang = 'en';
            }
            var post_id = this.post.post_id;
            var nextRequest = APPURL.LINK + 'post/' + lang + '/' + post_id;
            Axios.get(nextRequest).then(response => {
              this.$router.push({
                name: 'SinglePost',
                params: {
                  slug: response.data.data.results.post.slug,
                  lang: lang
                }
              });
            });
          });
          //console.log("we are in a ghanaHub or blog post");
        }
      } else {
        this.$router.push({ name: name, params: { lang: locale } });
      }
      //var nameLocale = this.$i18n.t("routes." + name);
      //var res = path.split("/");
      //this.$router.push({ name: name, params: { lang: locale } });
      // console.log(originalName);
      // console.log(lang);
      // console.log(name);
    },
    getLang(locale) {
      var value = 'navBar.' + locale;
      //console.log(value);
      return this.$i18n.t(value);
    }
  }
};
</script>

<style scoped>
.sub-menu {
  width: 120px !important;
}
</style>
